import React from 'react';
import Attribute from './common';
import { SubText } from '../../../common';

const notice = `Different number plates are commonplace.
Ensure the number plates on the car match the V5C documentation.
Be sure of what number plate comes with the car you are buying.`;

interface Props {
    passed: boolean;
}

const OriginalNumberPlate: React.FC<Props> = ({ passed }) => (
    <Attribute name="Original number plate" passed={passed}>
        <SubText>{notice}</SubText>
    </Attribute>
);

export default OriginalNumberPlate;
